'use client';
import { useState } from 'react';
import { Button } from '@heroui/button';
import { Link } from '@heroui/link';

import { Feature } from '../common/feature-variants';
import { motion } from 'framer-motion';

export default function HowItWorks() {
  const [steps] = useState([
    {
      id: 1,
      title: 'Register as a Super Agent or Sub-Agent',
      description: 'Simple sign-up process with required information.',
    },
    {
      id: 2,
      title: 'Complete Your Account Setup',
      description: 'Create passcodes, set transaction thresholds, and invite sub-agents.',
    },
    {
      id: 3,
      title: 'Start Facilitating Transactions',
      description:
        'Deposit, withdraw, and manage transactions for KiiBank and third-party services.',
    },
    {
      id: 4,
      title: 'Monitor & Optimize Performance',
      description: 'Track transactions, analyze insights, and improve services.',
    },
  ]);

  return (
    <section className="relative section-md border-t">
      <div className="container container-max">
        <div className="flex flex-col w-full space-y-5">
          <div className="flex flex-col items-start gap-16 ">
            <div className="flex-row items-center justify-between w-full space-y-3 md:flex">
              <div>
                <motion.h2
                  initial={{ opacity: 0, y: -50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2, ease: 'easeOut' }}
                  viewport={{ once: true }}
                  className="mb-2 leading-tight title text-dark-grey-900"
                >
                  How PayStop works?
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0, y: -5 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.5,
                    delay: 0.4,
                    ease: 'easeOut',
                  }}
                  viewport={{ once: true }}
                  className="text-sm font-medium leading-7 text-foreground/70"
                >
                  Step-by-Step Process: Guide potential agents through how to get started.
                </motion.p>
              </div>
              {/* <motion.div
                initial={{ opacity: 0, y: -5 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  delay: 0.5,
                  ease: 'easeOut',
                }}
                viewport={{ once: true }}
              >
                <Button
                  as={Link}
                  className="hover:bg-primary/80 hover:text-primary-foreground"
                  color="primary"
                  href="/become-an-agent"
                  radius="full"
                >
                  Become an Agent
                </Button>
              </motion.div> */}
            </div>

            <div className="grid w-full gap-10 md:grid-cols-2 lg:grid-cols-4">
              {steps.map((step, index) => (
                <motion.div
                  key={step.id} // Unique key for the motion div
                  className="flex"
                  initial={{ opacity: 0, y: -10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.5,
                    delay: 0.2 + index * 0.1, // Using index to control delay
                    ease: 'easeOut',
                  }}
                  viewport={{ once: true }}
                >
                  <Feature
                    key={step.id} // Unique key for Feature component
                    description={step.description}
                    title={step.title}
                    showIcon={false}
                    variant="numbered"
                    icon={''}
                    index={index + 0} // Start numbering from 1
                  />
                </motion.div>
              ))}
            </div>
          </div>
          <motion.div
            initial={{ opacity: 0, y: -5 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.5,
              delay: 0.5,
              ease: 'easeOut',
            }}
            viewport={{ once: true }}
            className="flex items-center gap-4"
          >
            <Button as={Link} color="primary" href="/how-it-works" radius="full" variant="bordered">
              Learn More
            </Button>
            <Link href="/become-agent">
              <Button color={'primary'} radius="full">
                Join as an Agent
              </Button>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
